import { X } from "lucide-react";
import { TargetPicker } from "@/components/TargetPicker";
import { EVENT_MAP, matchMinute, targetLabel } from "@/lib/events";

export const EditTargetModal = ({ event, match, onCancel, onSave }) => {
  const t = EVENT_MAP[event.type];
  return (
    <div data-testid="edit-target-modal" className="fixed inset-0 z-50 bg-black/85 backdrop-blur-md overflow-y-auto">
      <div className="rise max-w-6xl mx-auto p-4 sm:p-8">
        <div className="flex items-center justify-between gap-4 mb-6 bg-[#0A0A0A] border border-white/15 p-4">
          <div className="flex items-center gap-4 min-w-0">
            <span className="w-3 h-10 shrink-0" style={{ background: t.color }} />
            <div className="min-w-0">
              <p className="label-caps">Alterar jogador · atual: {event.team ? `${match[event.team].name} ${targetLabel(event)}` : "sem identificação"}</p>
              <h2 className="font-display text-3xl font-bold uppercase truncate">{t.label} · {matchMinute(event.seconds, event.period, match.half2_reset)}</h2>
            </div>
          </div>
          <button data-testid="edit-target-close" onClick={onCancel} className="tap w-12 h-12 border border-white/20 flex items-center justify-center hover:bg-white/10">
            <X size={22} />
          </button>
        </div>
        <div className="bg-[#0A0A0A] border border-white/15 p-3 sm:p-6">
          <TargetPicker match={match} playersOnly={t.playersOnly} onSelect={onSave} />
        </div>
      </div>
    </div>
  );
};
